/**
 * Shared icon+label action row under AI response cards (Summary / Ask AI).
 * startActions sit left; endActions are pushed right (wraps on narrow sidebar).
 */
const AiResponseActions = ({ startActions = [], endActions = [] }) => {
  const hasStart = startActions.length > 0;
  const hasEnd = endActions.length > 0;
  if (!hasStart && !hasEnd) return null;

  return (
    <div className="ra-response-actions" role="group">
      {hasStart && (
        <div className="ra-response-actions-start">
          {startActions.map((action) => (
            <ActionButton key={action.id} {...action} />
          ))}
        </div>
      )}
      {hasEnd && (
        <div className="ra-response-actions-end">
          {endActions.map((action) => (
            <ActionButton key={action.id} {...action} />
          ))}
        </div>
      )}
    </div>
  );
};

const ActionButton = ({
  label,
  icon,
  onClick,
  disabled = false,
  busy = false,
  muted = false,
  title,
}) => (
  <button
    type="button"
    className={`ra-response-action${busy ? " is-busy" : ""}${
      muted ? " is-muted" : ""
    }`}
    onClick={onClick}
    disabled={disabled || !onClick}
    title={title || label}
    aria-label={label}
    aria-busy={busy || undefined}
  >
    {icon ? (
      <span className="ra-response-action-icon" aria-hidden="true">
        {icon}
      </span>
    ) : null}
    <span className="ra-response-action-label">{label}</span>
  </button>
);

export default AiResponseActions;
